/**
 * The person's HOME entity, for the tab (sweep R2 #48, 2026-09-28).
 *
 * The filter bar's entity lives in sessionStorage and is empty in every new tab until a page
 * with a filter bar has loaded, and several paths then fell back to 'uk' — so a de-only user
 * who started in a fresh tab was sent to /a/uk/… or had + New › Prospect refused with "Your
 * access does not include UK." The right answer when the page does not know is the server's:
 * `/me/scope` with no entity binds the person's home entity (`scope.bind_entity(None)`). The
 * shell asks on every page and remembers the answer here; anything that still does not know
 * OMITS the entity (a request) or goes through a redirect route that asks (a link).
 */
import { salesApi } from '../services/sales-api.js';
import { getSavedFilterParams } from '../components/sales-filters.js';

const KEY = 'si_home_entity';

export function homeEntity() {
  try { return sessionStorage.getItem(KEY) || null; } catch { return null; }
}

export function rememberHomeEntity(entity) {
  if (!entity) return;
  try { sessionStorage.setItem(KEY, entity); } catch { /* private window: asked again next time */ }
}

/** The entity this tab means: the filter bar's, else the person's home one, else null. */
export function knownEntity() {
  return getSavedFilterParams().entity || homeEntity() || null;
}

/** The same, asking the server when nothing is known yet (for redirects that must pick one). */
export async function resolveEntity() {
  const known = knownEntity();
  if (known) return known;
  try {
    const res = await salesApi.getMyScope({});
    const e = (res.data || {}).entity || null;
    rememberHomeEntity(e);
    return e;
  } catch {
    return null;
  }
}
